import { graphql, useFragment } from 'react-relay';

import { getPriceAmountByType } from '../pricingGuidanceHelpers.ts';

import { type useGetEstimatedValueRange_item$key } from './__generated__/useGetEstimatedValueRange_item.graphql.ts';

const itemFragment = graphql`
    fragment useGetEstimatedValueRange_item on Item {
        ...pricingGuidanceHelpers_item
    }
`;

export const useGetEstimatedValueRange = ({
    item: itemRef,
    currency,
}: {
    item: useGetEstimatedValueRange_item$key | null;
    currency: string;
}): { rangeMin: number; rangeMax: number } => {
    const item = useFragment(itemFragment, itemRef);

    const rangeMin = getPriceAmountByType({ item: item || null, currency, type: 'MIN' });
    const rangeMax = getPriceAmountByType({ item: item || null, currency, type: 'MAX' });

    return { rangeMin, rangeMax };
};
